"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredictedBroadbandSpeeds$ = exports.PredictedBroadbandSpeeds$outboundSchema = exports.PredictedBroadbandSpeeds$inboundSchema = void 0;
exports.predictedBroadbandSpeedsToJSON = predictedBroadbandSpeedsToJSON;
exports.predictedBroadbandSpeedsFromJSON = predictedBroadbandSpeedsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.PredictedBroadbandSpeeds$inboundSchema = z.object({
    available: z.nullable(z.boolean()),
    broadband_type: z.string(),
    maximum_predicted_download_speed: z.nullable(z.number()),
    maximum_predicted_upload_speed: z.nullable(z.number()),
    nature_of_supply: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "broadband_type": "broadbandType",
        "maximum_predicted_download_speed": "maximumPredictedDownloadSpeed",
        "maximum_predicted_upload_speed": "maximumPredictedUploadSpeed",
        "nature_of_supply": "natureOfSupply",
    });
});
/** @internal */
exports.PredictedBroadbandSpeeds$outboundSchema = z.object({
    available: z.nullable(z.boolean()),
    broadbandType: z.string(),
    maximumPredictedDownloadSpeed: z.nullable(z.number()),
    maximumPredictedUploadSpeed: z.nullable(z.number()),
    natureOfSupply: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        broadbandType: "broadband_type",
        maximumPredictedDownloadSpeed: "maximum_predicted_download_speed",
        maximumPredictedUploadSpeed: "maximum_predicted_upload_speed",
        natureOfSupply: "nature_of_supply",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PredictedBroadbandSpeeds$;
(function (PredictedBroadbandSpeeds$) {
    /** @deprecated use `PredictedBroadbandSpeeds$inboundSchema` instead. */
    PredictedBroadbandSpeeds$.inboundSchema = exports.PredictedBroadbandSpeeds$inboundSchema;
    /** @deprecated use `PredictedBroadbandSpeeds$outboundSchema` instead. */
    PredictedBroadbandSpeeds$.outboundSchema = exports.PredictedBroadbandSpeeds$outboundSchema;
})(PredictedBroadbandSpeeds$ || (exports.PredictedBroadbandSpeeds$ = PredictedBroadbandSpeeds$ = {}));
function predictedBroadbandSpeedsToJSON(predictedBroadbandSpeeds) {
    return JSON.stringify(exports.PredictedBroadbandSpeeds$outboundSchema.parse(predictedBroadbandSpeeds));
}
function predictedBroadbandSpeedsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PredictedBroadbandSpeeds$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PredictedBroadbandSpeeds' from JSON`);
}
//# sourceMappingURL=predictedbroadbandspeeds.js.map